module.exports = "<nv-react-component component=\"OrgMentorAdminPanel\"></nv-react-component>";